import { useIntl } from "react-intl"
import { emptyPlaceholder } from "src/common/emptyPlaceholder"
import { messages } from "./warrantyDurationSaleAcitivtyMesssages"

export const usePorscheApprovedWarrantyDurationText = ({
	sale,
}: {
	sale?: {
		warrantyDurationInMonths: number
		withAssistance: boolean
	}
}): string => {
	const { formatMessage } = useIntl()

	if (sale?.withAssistance) {
		return formatMessage(messages.monthsWithPorscheAssistance, {
			warrantyPeriod: sale.warrantyDurationInMonths,
		})
	}

	if (sale) {
		return formatMessage(messages.months, {
			warrantyPeriod: sale.warrantyDurationInMonths,
		})
	}

	return emptyPlaceholder
}
